export default "__VITE_ASSET__BzC6THl5__"